import { render, staticRenderFns } from "./ticket-table.vue?vue&type=template&id=9a7e79d0"
import script from "./ticket-table.vue?vue&type=script&lang=js"
export * from "./ticket-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a7e79d0')) {
      api.createRecord('9a7e79d0', component.options)
    } else {
      api.reload('9a7e79d0', component.options)
    }
    module.hot.accept("./ticket-table.vue?vue&type=template&id=9a7e79d0", function () {
      api.rerender('9a7e79d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ticket-table.vue"
export default component.exports